import React, {Component} from "react";
import{
    Row,
    Col,
    Card,
    CardBody,
    CardFooter,
    UncontrolledTooltip
} from 'reactstrap';
import { Link,NavLink } from "react-router-dom";
import DatePicker from "react-datepicker";
import swal from 'sweetalert';
import LoadingScreen, { __esModule } from 'react-loading-screen';
import NumberFormat from 'react-number-format';

import moment from 'moment-timezone';
import Select from "react-select";
import Breadcrumbs from '../../component/Breadcrumb';
import logo from "../../images/logo/logo.png";
import API from '../../helpers/API';
import{
    infoSession,
    toAngka,
    showInOut,
    urlBackend,
    showRole,
    showStatusAktif,
    saveTanggal,
    showTanggal,
    showTanggalJam,
    showStatusProses
} from '../../config/Utils';
import "react-datepicker/dist/react-datepicker.css";
moment.tz.setDefault("Asia/Makassar");

const date_now = new Date();
let newOffset = 25;
class Produk extends Component {
    constructor(props){
        super(props);
        this.state = {
            isReady:false,
            isLoading:false,
            xOperator:infoSession('id'),
            dataSatuan:[],
            dataClient:[],
            dataSupplier:[],
            dataTable:[],
            fTglAwal:date_now,
            fTglAkhir:new Date().setDate(date_now.getDate()+1),
            fNamaItem:'',
            fHsCode:'',
            fSku:'',

            xId:'',
            xBarcode:'',
            xNamaItem:'',
            xStyle:'',
            xColor:'',
            xSize:'',
            xSatuan:'',
            xPrice:'',
            xSku:'',
            xHsCode:'',
            xMaterial:'',
            xCostPrice:'',
            xQty:'',

            xPengirim:'',
            xPenerima:'',
            xQtyOut:'',
            xQtyIn:'',
            offset:0,
            limit:25,
            showMore:'none',
            totalData:0
        }

        this._handleInputChange=this._handleInputChange.bind(this);
    }

    _handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    _handleInputChangeSelected(event, name){
        if(event){
            this.setState({
                [name]: event,
            })
        }
    };

    _clearFilter(){
        this.setState({
            fTglAwal:date_now,
            fTglAkhir:new Date().setDate(date_now.getDate()+1),
            fNamaItem:'',
            fHsCode:'',
            fSku:'',
        })
    }

    _clearBox(){
        this.setState({
            xId:'',
            xBarcode:'',
            xNamaItem:'',
            xStyle:'',
            xColor:'',
            xSize:'',
            xSatuan:'',
            xPrice:'',
            xSku:'',
            xHsCode:'',
            xMaterial:'',
            xCostPrice:'',
            xQty:'',
            xPengirim:'',
            xPenerima:'',
            xQtyOut:'',
            xQtyIn:'',
        })
    }

    _loadDataTable(param, tipe){
        API.get('produk',{params:param}).then(res=>{
            let total = 0;
            let more = "none";
            let ar = [...this.state.dataTable];
            if(res.data.result){
                //if(res.data.length){
                    let x = JSON.parse(res.data.data);
                    if(tipe==1){
                        //let x = JSON.parse([...res.data.data]);
                        //console.log(x);
                        x.map((item, index)=>{
                            ar.push(x[index]);
                        })
                    }else{
                        ar = x;
                    }
                    total=res.data.jumlah_data;
                //};
            };
            if(ar.length<total){
                more=''
            }
            //console.log(ar);
            this.setState({
                dataTable:ar,
                totalData:total,
                showMore:more,
                isLoading:false,
                isReady:true
            })
        });
    }

    _nextPage(){
        newOffset = newOffset+this.state.limit+1;
        let param = {
            nama_item:this.state.fNamaItem,
            sku:this.state.fSku,
            hs_code:this.state.fHsCode,
            offset:newOffset,
            limit:this.state.limit
        };

        this._loadDataTable(param,1);
    }

    _exportExcel(){
        var link_file=urlBackend()+"produk/excel?nama_item="+this.state.fNamaItem+"&barcode="+this.state.fBarcode+"&sku="+this.state.fSku+"&hs_code="+this.state.fHsCode;
        window.open(link_file);
        this._loading(false);
    }


    _loadDataSatuan(){
        API.get('satuan').then(res=>{
            let ar = [];
            if(res.data.result){
                if(res.data.data.length){
                    ar = res.data.data;
                };
            };
            this.setState({
                dataSatuan:ar,
            })
        })
    }

    _loadDataClient(){
        API.get('client').then(res=>{
            let ar = [];
            if(res.data.result){
                if(res.data.data.length){
                    ar = res.data.data;
                };
            };
            this.setState({
                dataClient:ar,
            })
        })
    }

    _loadDataSupplier(){
        API.get('supplier').then(res=>{
            let ar = [];
            if(res.data.result){
                if(res.data.data.length){
                    ar = res.data.data;
                };
            };
            this.setState({
                dataSupplier:ar,
            })
        })
    }

    _loadData(item){
        this._clearBox();
        if(item){
            this.setState({
                xId:item.id,
                xBarcode:item.barcode,
                xNamaItem:item.nama_item,
                xStyle:item.style,
                xColor:item.color,
                xSize:item.size,
                xSatuan:{value:item.satuan,label:item.satuan},
                xPrice:item.price,
                xSku:item.sku,
                xHsCode:item.hs_code,
                xMaterial:item.material,
                xCostPrice:item.cost_price,
                xQty:item.qty,
            })
        }
    }

    _loading(status){
        this.setState({
            isLoading:status
        });
    }

    _notif(type,title,message){
        swal({
            title: title,
            text: message,
            icon: type,
        });
    }

    _add(){
        if(!this.state.xNamaItem){
            this._notif('error', 'Error', 'Item name cannot be empty');
            return false;
        };

        var param = {
            user:this.state.xOperator,
            barcode:this.state.xBarcode,
            nama_item:this.state.xNamaItem,
            style:this.state.xStyle,
            color:this.state.xColor,
            size:this.state.xSize,
            satuan:this.state.xSatuan.value,
            price:toAngka(this.state.xPrice),
            sku:this.state.xSku,
            hs_code:this.state.xHsCode,
            material:this.state.xMaterial,
            cost_price:toAngka(this.state.xCostPrice),
            qty:toAngka(this.state.xQty),
        };

        this._loading(true);
        API.post('produk',param).then(res=>{
            if(res){
                if(res.data.result){
                    document.getElementById('btn-batal-form').click();
                    this._loading(false);
                    this._clearBox();
                    var param = {
                        nama_item:this.state.fNamaItem,
                        sku:this.state.fSku,
                        hs_code:this.state.fHsCode,
                        offset:this.state.offset,
                        limit:this.state.limit
                    };
                    this._loadDataTable(param);
                }else{
                    this._loading(false);
                    this._notif('error', 'Error', res.data.message);
                    return false;
                }
            }else{
                this._loading(true);
                this._notif('error', 'Error', "Can't connect to server");
                return false;
            }
        }).catch(error=>{
            this._loading(false);
            this._notif('error', 'Error', error.message);
            return false;
        })

    }

    _update(){
        if(!this.state.xNamaItem){
            this._notif('error', 'Error', 'Item name cannot be empty');
            return false;
        };

        var param = {
            user:this.state.xOperator,
            barcode:this.state.xBarcode,
            nama_item:this.state.xNamaItem,
            style:this.state.xStyle,
            color:this.state.xColor,
            size:this.state.xSize,
            satuan:this.state.xSatuan.value,
            price:toAngka(this.state.xPrice),
            sku:this.state.xSku,
            hs_code:this.state.xHsCode,
            material:this.state.xMaterial,
            cost_price:toAngka(this.state.xCostPrice),
            qty:toAngka(this.state.xQty),
        };

        this._loading(true);
        API.put('produk/'+this.state.xId,param).then(res=>{
            if(res){
                if(res.data.result){
                    document.getElementById('btn-batal-form').click();
                    this._loading(false);
                    this._clearBox();
                    var param = {
                        nama_item:this.state.fNamaItem,
                        sku:this.state.fSku,
                        hs_code:this.state.fHsCode,
                        offset:this.state.offset,
                        limit:this.state.limit
                    };
                    this._loadDataTable(param);
                }else{
                    this._loading(false);
                    this._notif('error', 'Error', res.data.message);
                    return false;
                }
            }else{
                this._loading(true);
                this._notif('error', 'Error', "Can't connect to server");
                return false;
            }
        }).catch(error=>{
            this._loading(false);
            this._notif('error', 'Error', error.message);
            return false;
        })
    }

    _delete(){
        if(!this.state.xId){
            this._notif('error','Error', 'No data has been selected yet.');
            return false;
        };

        API.delete('produk/'+this.state.xId).then(res=>{
            if(res){
                if(res.data.result){
                    this._loading(false);
                    this._clearBox();
                    document.getElementById('btn-batal-hapus').click();
                    var param = {
                        nama_item:this.state.fNamaItem,
                        sku:this.state.fSku,
                        hs_code:this.state.fHsCode,
                        offset:this.state.offset,
                        limit:this.state.limit
                    };
                    this._loadDataTable(param);
                }else{
                    this._loading(false);
                    this._notif('error', 'Error', res.data.message);
                    return false;
                }
            }else{
                this._loading(false);
                this._notif('error', 'Error', "Can't connect to server.")
                return false;
            }
        }).catch(error=>{
            this._loading(false);
            this._notif('error', 'Error', error.message);
            return false;
        })
    }


    _submit(){
        if(this.state.xId){
            this._update();
        }else{
            this._add();
        }
    }

    _submitIn(){
        if(!this.state.xPengirim){
            this._notif('error', 'Error', 'Sender cannot be empty');
            return false;
        };

        if(!this.state.xQtyIn){
            this._notif('error', 'Error', 'Qty cannot be empty');
            return false;
        };

        var ket = "Sent "+this.state.xNamaItem+" from "+this.state.xPengirim.label+" to Office";
        var param={
            id:this.state.xId,
            user:this.state.xOperator,
            penerima:'0',
            pengirim:this.state.xPengirim.value,
            produk:this.state.xId,
            jumlah:toAngka(this.state.xQtyIn),
            satuan:this.state.xSatuan.label,
            tipe_trx:'IN',
            keterangan:ket,

            barcode:this.state.xBarcode,
            nama_item:this.state.xNamaItem,
            style:this.state.xStyle,
            color:this.state.xColor,
            size:this.state.xSize,
            price:toAngka(this.state.xPrice),
            sku:this.state.xSku,
            hs_code:this.state.hs_code,
            material:this.state.xMaterial,
            qty:toAngka(this.state.xQtyIn)
        }

        API.post('produk/terima', param).then(res=>{
            if(res){
                if(res.data.result){
                    this._loading(false);
                    this._clearBox();
                    document.getElementById('btn-batal-in').click();
                    var param = {
                        nama_item:this.state.fNamaItem,
                        sku:this.state.fSku,
                        hs_code:this.state.fHsCode,
                        offset:this.state.offset,
                        limit:this.state.limit
                    };
                    this._loadDataTable(param);
                }else{
                    this._loading(false);
                    this._notif('error', 'Error', res.data.message);
                    return false;
                }
            }else{
                this._loading(false);
                this._notif('error', 'Error', "Can't connect to server.")
                return false;
            }
        }).catch(error=>{
            this._loading(false);
            this._notif('error', 'Error', error.message);
            return false;
        })

    }

    _submitOut(){
        if(!this.state.xPenerima){
            this._notif('error', 'Error', 'Receiver cannot be empty');
            return false;
        };

        if(!this.state.xQtyOut){
            this._notif('error', 'Error', 'Qty cannot be empty');
            return false;
        };

        if(eval(this.state.xQty)<eval(this.state.xQtyOut)){
            this._notif('error', 'Error', 'Not enough stock');
            return false;
        }

        var ket = "Sent "+this.state.xNamaItem+" from Office to "+this.state.xPenerima.label;
        var param={
            id:this.state.xId,
            user:this.state.xOperator,
            penerima:this.state.xPenerima.value,
            pengirim:'0',
            produk:this.state.xId,
            jumlah:toAngka(this.state.xQtyOut),
            satuan:this.state.xSatuan.label,
            tipe_trx:'OUT',
            keterangan:ket,

            barcode:this.state.xBarcode,
            nama_item:this.state.xNamaItem,
            style:this.state.xStyle,
            color:this.state.xColor,
            size:this.state.xSize,
            price:toAngka(this.state.xPrice),
            sku:this.state.xSku,
            hs_code:this.state.hs_code,
            material:this.state.xMaterial,
            qty:toAngka(this.state.xQtyOut)
        }

        API.post('produk/kirim', param).then(res=>{
            if(res){
                if(res.data.result){
                    this._loading(false);
                    this._clearBox();
                    document.getElementById('btn-batal-out').click();
                    var param = {
                        nama_item:this.state.fNamaItem,
                        sku:this.state.fSku,
                        hs_code:this.state.fHsCode,
                        offset:this.state.offset,
                        limit:this.state.limit
                    };
                    this._loadDataTable(param);
                }else{
                    this._loading(false);
                    this._notif('error', 'Error', res.data.message);
                    return false;
                }
            }else{
                this._loading(false);
                this._notif('error', 'Error', "Can't connect to server.")
                return false;
            }
        }).catch(error=>{
            this._loading(false);
            this._notif('error', 'Error', error.message);
            return false;
        })

    }

    componentDidMount() {
        if(this.state.isLoading){
            if(this.state.isLoading){
                this.setState({
                    isReady:true,
                    isLoading:false
                });
            }
        }
    }


    render(){
        if(!this.state.isReady){
            this.setState({
                isReady:true,
                isLoading:false
            });
            this._loadDataSatuan();
            this._loadDataClient();
            this._loadDataSupplier();

            var param = {
                nama_item:this.state.fNamaItem,
                sku:this.state.fSku,
                hs_code:this.state.fHsCode,
                offset:this.state.offset,
                limit:this.state.limit
            };
            this._loadDataTable(param);
        };

        return(
            <React.Fragment>
                <LoadingScreen
                    loading={this.state.isLoading}
                    bgColor='#f1f1f1'
                    spinnerColor='#9ee5f8'
                    textColor='#676767'
                    logoSrc={logo}
                    text=''
                >
                     <Breadcrumbs title="" breadcrumbItem="STOK / PRODUCT OFFICE" />
                     <Row>
                        <Col>
                            <div className="card shadow-none border">
                                <div className='card-body'>
                                    <Row>
                                        <Col xl={6} md={6} sm={12} xs={12}>
                                            <div className="input-group mb-3">
                                                <div className="col-md-4">
                                                    <span className="input-group-text">Item Name</span>
                                                </div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control" name="fNamaItem" value={this.state.fNamaItem} onChange={this._handleInputChange.bind(this)}></input>
                                                </div>
                                            </div>
                                            <div className="input-group mb-3">
                                                <div className="col-md-4">
                                                    <span className="input-group-text">SKU</span>
                                                </div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control" name="fSku" value={this.state.fSku} onChange={this._handleInputChange.bind(this)}></input>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xl={6} md={6} sm={12} xs={12}>
                                            <div className="input-group mb-3">
                                                <div className="col-md-4">
                                                    <span className="input-group-text">HS Code</span>
                                                </div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control" name="fHsCode" value={this.state.fHsCode} onChange={this._handleInputChange.bind(this)}></input>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xl={8} md={8} sm={12} xs={12}></Col>
                                        <Col xl={4} md={4} sm={12} xs={12}>
                                            <button type="button" className="btn btn-primary btn-flat btn-block waves-effect waves-light float-end mr-2" onClick={()=>{
                                               var param = {
                                                nama_item:this.state.fNamaItem,
                                                sku:this.state.fSku,
                                                hs_code:this.state.fHsCode,
                                                offset:this.state.offset,
                                                limit:this.state.limit
                                            };
                                               this._loadDataTable(param);
                                             }}>Filter</button> 
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <div className="btn-group p-2" role="group">
                                <button type="button" className="btn btn-primary mr-2" data-toggle="modal" data-target="#modal-form" onClick={()=>{
                                    this._clearBox()
                                }}>
                                <i className="fas fa-edit"></i> Add New
                                </button>

                                <button type="button" className="btn btn-primary mr-2" onClick={()=>{
                                    this._exportExcel();
                                }}>
                                <i className="fas fa-download"></i> Export to Excel
                                </button>

                                <button type="button" className="btn btn-primary" onClick={()=>{
                                    window.location.reload(true);
                                }}>
                                <i className="fas fa-recycle"></i> Refresh
                                </button>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col xl={12} md={12} sm={12} xs={12}>
                            <div className="card shadow-none border">
                                <div className='card-body'>
                                    <div className="table-responsive">
                                        <table className="table align-middle table-nowrap table-hover mb-0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" style={{width:'50px'}}></th>
                                                    <th scope="col" style={{width:'100px'}}>BARCODE</th>
                                                    <th scope="col">PRODUCT NAME</th>
                                                    <th scope="col">STYLE</th>
                                                    <th scope="col">COLOR</th>
                                                    <th scope="col">MATERIAL</th>
                                                    <th scope="col">SKU</th>
                                                    <th scope="col">HS CODE</th>
                                                    <th scope="col">SIZE</th>
                                                    <th scope="col">COST PRICE</th>
                                                    <th scope="col">PRICE</th>
                                                    <th scope="col" style={{width:'100px'}}>QTY</th>
                                                    <th scope="col" style={{width:'100px'}}>UNIT</th>
                                                    <th style={{width:'100px'}}></th> 
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.dataTable.map((item, index)=>{
                                                        return(
                                                            <React.Fragment key={"f_"+index}>
                                                                <tr key={'row_'+index}>
                                                                    <td className="center">
                                                                                                            <div className="action-buttons">
                                                                                                                <NavLink to="#" className="green bigger-140 show-details-btn" title="Show Details">
                                                                                                                    <i className="ace-icon fa fa-angle-double-down"></i>
                                                                                                                    <span className="sr-only">Details</span>
                                                                                                                </NavLink>
                                                                                                            </div>
                                                                    </td>
                                                                    <td>{item.barcode}</td>
                                                                    <td>{item.nama_item}</td>
                                                                    <td>{item.style}</td>
                                                                    <td>{item.color}</td>
                                                                    <td>{item.material}</td>
                                                                    <td>{item.sku}</td>
                                                                    <td>{item.hs_code}</td>
                                                                    <td>{item.size}</td>
                                                                    <td><NumberFormat displayType="text" value={item.cost_price} thousandSeparator={true} prefix={''} decimalScale={0} style={{textAlign:"right"}} /></td>
                                                                    <td><NumberFormat displayType="text" value={item.price} thousandSeparator={true} prefix={''} decimalScale={0} style={{textAlign:"right"}} /></td>
                                                                    <td>{item.qty}</td>
                                                                    <td>{item.satuan}</td>
                                                                    <td style={{textAlign:"center"}}>
                                                                        <div className="dropdown">
                                                                            <NavLink to="#" className="font-size-16 text-muted dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true">
                                                                                <i className="fas fa-ellipsis-h fa-lg"></i>
                                                                            </NavLink>
                                                                            <div className="dropdown-menu dropdown-menu-end">
                                                                                <a className="dropdown-item" data-toggle="modal" data-target="#modal-form" onClick={()=>{
                                                                                    this._loadData(item);
                                                                                }}><i className="fas fa-edit mr-2"></i> Edit</a>
                                                                                 <a className="dropdown-item" data-toggle="modal" data-target="#modal-form" onClick={()=>{
                                                                                    this._loadData(item);
                                                                                }}><i className="fas fa-trash mr-2"></i> Delete</a>
                                                                                <div className="divider"></div>

                                                                                <a className="dropdown-item" data-toggle="modal" data-target="#modal-in" onClick={()=>{
                                                                                    this._loadData(item);
                                                                                }}><i className="fas fa-arrow-right mr-2"></i> In</a>
                                                                                <a className="dropdown-item" data-toggle="modal" data-target="#modal-out" onClick={()=>{
                                                                                    this._loadData(item);
                                                                                }}><i className="fas fa-arrow-left mr-2"></i> Out</a>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr className="detail-row">
                                                                    <td colSpan="13">
                                                                        <div className="table-detail">
                                                                            <div className="row">
                                                                                <div className="col-xs-12 col-sm-12">
                                                                                    <div className='card'>
                                                                                        <div className='card-body'>
                                                                                            <div className="table-header">HISTORY</div>
                                                                                            <div className="table-responsive">
                                                                                                <table className="table align-middle table-nowrap table-hover mb-0">
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th scope="col" style={{width:'100px'}}>IN/OUT</th>
                                                                                                            <th scope="col">DESCRIPTION</th>
                                                                                                            <th scope="col" style={{width:'100px'}}>QTY</th>
                                                                                                            <th scope="col" style={{width:'100px'}}>UNIT</th>
                                                                                                            <th scope="col" style={{width:'100px'}}>DATE</th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        {
                                                                                                            item.log.map((rec, no)=>{
                                                                                                                return(
                                                                                                                    <React.Fragment key={"x_"+index}>
                                                                                                                        <tr key={'rowx_'+index}>
                                                                                                                            <td>{showInOut(rec[9])}</td>
                                                                                                                            <td>{rec[6]}</td>
                                                                                                                            <td>{rec[7]}</td>
                                                                                                                            <td>{rec[8]}</td>
                                                                                                                            <td>{showTanggalJam(rec[1])}</td>
                                                                                                                        </tr>
                                                                                                                    </React.Fragment>
                                                                                                                )
                                                                                                            })
                                                                                                        }
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </React.Fragment>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row style={{display:this.state.showMore}}>
                            <Col xs="12">
                                <div className="text-center my-3">
                                    <Link to="#" onClick={()=>{this._nextPage()}} className="text-success"><i className="fas fa-spinner bx-spin mr-2"></i> Load more </Link>
                                </div>
                            </Col>
                    </Row>

                    <div id="modal-form" className="modal fade-scale" tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header no-padding">
                                    <h5 className="modal-title"></h5>
                                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col xl={12} md={12} sm={12} xs={12}>
                                            <div className="table-header">Detail Product</div>
                                            <div className='profile-user-info profile-user-info-striped'>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Barcode</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xBarcode" value={this.state.xBarcode} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Produk Name</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xNamaItem" value={this.state.xNamaItem} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Style</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xStyle" value={this.state.xStyle} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Color</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xColor" value={this.state.xColor} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Material</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xMaterial" value={this.state.xMaterial} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>SKU</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xSku" value={this.state.xSku} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>HS Code</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xHsCode" value={this.state.xHsCode} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Size</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xSize" value={this.state.xSize} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Cost Price</div>
                                                    <div className='profile-info-value'>
                                                        <NumberFormat className="form-control" name="xCostPrice" placeholder="0" value={this.state.xCostPrice} thousandSeparator={true} prefix={''} decimalScale={0} style={{textAlign:"right"}} onChange={this._handleInputChange.bind(this)} />
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Price</div>
                                                    <div className='profile-info-value'>
                                                        <NumberFormat className="form-control" name="xPrice" placeholder="0" value={this.state.xPrice} thousandSeparator={true} prefix={''} decimalScale={0} style={{textAlign:"right"}} onChange={this._handleInputChange.bind(this)} />
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Qty</div>
                                                    <div className='profile-info-value'>
                                                        <NumberFormat maxLength={10} className="form-control" name="xQty" placeholder="0" value={this.state.xQty} thousandSeparator={true} prefix={''} decimalScale={0} style={{textAlign:"right"}} onChange={this._handleInputChange.bind(this)} />
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Unit</div>
                                                    <div className='profile-info-value'>
                                                        <Select value={this.state.xSatuan} name="xSatuan" options={this.state.dataSatuan.map(e=>({value:e[1], label:e[1]}))} onChange={(e)=>{this._handleInputChangeSelected(e,"xSatuan")}} />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                       
                                    </Row>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-white btn-primary btn-round" onClick={()=>{
                                        this._submit();
                                    }}>Save</button>
                                    <button id="btn-batal-form" data-dismiss="modal" className="btn btn-white btn-danger btn-round" style={{marginLeft:'5px'}}>
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="modal-in" className="modal fade-scale" tabIndex="-1">
                        <div className="modal-dialog modal-md">
                            <div className="modal-content">
                                <div className="modal-header no-padding">
                                    <h5 className="modal-title">PRODUCT IN</h5>
                                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col xl={12} md={12} sm={12} xs={12}>
                                            <div className='profile-user-info profile-user-info-striped'>
                                                <div className="table-header">Receiver</div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Product Name</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" value={this.state.xNamaItem} disabled></input>
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Sent to</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" value={'OFFICE'} disabled></input>
                                                    </div>
                                                </div>
                                                <div className="table-header">Sender</div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>From</div>
                                                    <div className='profile-info-value'>
                                                        <Select value={this.state.xPengirim} name="xPengirim" options={this.state.dataSupplier.map(e=>({value:e[0], label:e[1]}))} onChange={(e)=>{this._handleInputChangeSelected(e,"xPengirim")}} />
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Qty</div>
                                                    <div className='profile-info-value'>
                                                        <NumberFormat maxLength={10} className="form-control" name="xQtyIn" placeholder="0" value={this.state.xQtyIn} thousandSeparator={true} prefix={''} decimalScale={0} style={{textAlign:"right"}} onChange={this._handleInputChange.bind(this)} />
                                                    </div>
                                                </div>

                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-white btn-primary btn-round" onClick={()=>{
                                        this._submitIn();
                                    }}>Submit</button>
                                    <button id="btn-batal-in" data-dismiss="modal" className="btn btn-white btn-danger btn-round" style={{marginLeft:'5px'}}>
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="modal-out" className="modal fade-scale" tabIndex="-1">
                        <div className="modal-dialog modal-md">
                            <div className="modal-content">
                                <div className="modal-header no-padding">
                                    <h5 className="modal-title">PRODUCT OUT</h5>
                                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col xl={12} md={12} sm={12} xs={12}>
                                            <div className='profile-user-info profile-user-info-striped'>
                                                <div className="table-header">Sender</div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Product Name</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" value={this.state.xNamaItem} disabled></input>
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>From</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" value={'OFFICE'} disabled></input>
                                                    </div>
                                                </div>
                                                <div className="table-header">Receiver</div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Sent to</div>
                                                    <div className='profile-info-value'>
                                                        <Select value={this.state.xPenerima} name="xPenerima" options={this.state.dataClient.map(e=>({value:e[0], label:e[1]}))} onChange={(e)=>{this._handleInputChangeSelected(e,"xPenerima")}} />
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Qty</div>
                                                    <div className='profile-info-value'>
                                                        <NumberFormat maxLength={10} className="form-control" name="xQtyOut" placeholder="0" value={this.state.xQtyOut} thousandSeparator={true} prefix={''} decimalScale={0} style={{textAlign:"right"}} onChange={this._handleInputChange.bind(this)} />
                                                    </div>
                                                </div>

                                            </div>
                                        </Col>
                                    </Row>

                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-white btn-primary btn-round" onClick={()=>{
                                        this._submitOut();
                                    }}>Submit</button>
                                    <button id="btn-batal-out" data-dismiss="modal" className="btn btn-white btn-danger btn-round" style={{marginLeft:'5px'}}>
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </LoadingScreen>

            </React.Fragment>
        )
    }



}

export default Produk;